<template>
  <div
    ref="chart"
    style="height: 100%; width: 100%"
  />
</template>

<script>
import Plotly from 'plotly.js-cartesian-dist-min'

export default {
  props: {
    data: Object, // { x: Array },
    binSize: {
      type: Number,
      default: 1
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    xAxis: {
      type: Object,
      default: () => null
    },
    title: {
      type: String,
      required: false
    }
  },

  computed: {
    histogramData () {
      return [{
        x: (this.data && this.data.x) || [],
        xbins: {
          size: this.binSize
        },
        type: 'histogram',
        marker: {
          color: 'green'
        }
      }]
    },

    histogramLayout () {
      return {
        title: this.title || '',
        showLegend: this.showLegend,
        hoverlabel: { bgcolor: '#515a6e' },
        xaxis: this.xAxis ? {
          title: this.xAxis.name,
          automargin: true
        } : { showticklabels: false },
        yaxis: {
          autorange: true,
          title: 'Count',
          automargin: true
        }
      }
    }
  },

  watch: {
    histogramData: {
      handler () {
        this.loadChart()
      },
      deep: true
    },

    histogramLayout: {
      handler () {
        this.loadChart()
      },
      deep: true
    }
  },

  mounted () {
    this.loadChart()
  },

  methods: {
    /**
     * Loads the Histogram
     */
    loadChart () {
      const { chart } = this.$refs

      Plotly.newPlot(chart, this.histogramData, this.histogramLayout, { responsive: true })
    }
  }
}
</script>
